<template>
  <div id="tpl">
    <div id="toolbar" style="text-align: right;">
      <el-form :model="keywords" size="small" inline>
        <el-form-item label="模板名称" prop="theme__name__icontains">
          <el-input v-model="keywords.theme__name__icontains" placeholder="请输入模板名称"/>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="getTableDate(1)"><i class="fa fa-search"></i>模板搜索</el-button>
            <el-button type="primary" @click="newShow = true"><i class="fa fa-creative-commons"></i>创建新模板</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <div style="display: block">
      <el-row style="display: flex; align-items: stretch;" :gutter="16">
        <el-col v-for="tpl in tableDate" :key="tpl.ID" :span="6" style="padding: 16px;" class="tplcell">
          <div class="shot">
            <img :src="tpl.theme.screenShot ? tpl.theme.screenShot : '//img.initcdn.com/20190930/27c94f23409c4e539a65e65d725f0aef.png'" style="object-fit: cover; max-width: 100%;"/>
          </div>
          <h3>{{tpl.theme.name}}<el-button size="mini" :style="{'margin-left': '8px','font-weight': 'bold', color: shop.theme_id === tpl.ID ? 'green' : 'red'}" type="text">{{shop.theme_id === tpl.ID ? '使用中' : '待启用'}}</el-button></h3>
          <div style="text-align: right;">
            <el-button-group v-if="tpl.theme.inited">
              <el-button type="info" size="mini" @click="initDevTpl(tpl)">开发</el-button>
              <el-button type="info" size="mini">下载</el-button>
              <el-button type="info" size="mini" v-if="shop.merchant_id === tpl.theme.merchant_id">发布</el-button>
              <el-button type="info" size="mini" v-if="shop.merchant_id === tpl.theme.merchant_id">信息</el-button>
              <el-button type="info" @click="tplExchange(tpl.ID)" v-if="shop.theme_id !== tpl.ID" size="mini">启用</el-button>
            </el-button-group>
            <el-button-group v-else>
              <el-button type="info" size="mini" @click="createTplFiles(tpl.ID)" v-if="shop.merchant_id === tpl.theme.merchant_id">模板初始化</el-button>
              <el-button v-else type="text" style="color: red;">待开放</el-button>
            </el-button-group>
          </div>
        </el-col>
      </el-row>
      <el-pagination
        @current-change="getTableDate"
        :current-page.sync="tablePageinfo.page"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="tablePageinfo.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="newShow">
      <h3 slot="title">创建新的商户模板</h3>
      <el-form :model="newCurr" ref="newForm" size="small">
        <el-form-item label="模板名称" prop="name" required>
          <el-input v-model="newCurr.name" placeholder="请输入模板的名称"/>
        </el-form-item>
        <el-form-item label="模板预览图" prop="screenShot">
          <el-upload
            class="avatar-uploader"
            :data="uploadattr"
            accept="image/*"
            name="upload"
            :headers="$verifyhead"
            :action="upurl"
            :show-file-list="false"
            :on-success="handleShortcutSuccuss">
            <img v-if="newCurr.screenShot" :src="newCurr.screenShot" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-input v-model="newCurr.screenShot" style="display: none"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: right;">
        <el-button-group>
          <el-button type="primary" @click="handle('newForm')">创建新的模板</el-button>
        </el-button-group>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="devShow" fullscreen>
      <el-row :gutter="26">
        <el-col :span="4">
          <ul style="list-style: none;">
            <li style="text-align: left; padding: 0;">
              <el-button @click="changeTpl('layout', 'layout.html')" :type="currTpl === 'layout' ? 'success' : 'text'" style="width: 100%; text-align: left;">
                布局模板
              </el-button>
            </li>
            <li v-for="tpl in storetpl" :key="tpl.ID" style="padding: 0; text-align: left;">
              <el-button @click="changeTpl(tpl.functionName, tpl.tpl)" :type="currTpl === tpl.functionName ? 'success' : 'text'" style="width: 100%; text-align: left;">
               {{tpl.intro}}
              </el-button>
            </li>
          </ul>
        </el-col>
        <el-col :span="20">
          <codemirror  ref="devHtml" v-model="devHtml" :options="cmOptions" class="devCode" style="height: 80vh!important;"></codemirror>
        </el-col>
      </el-row>
      <div style="text-align: right" slot="footer">
        <el-button type="primary" @click="handleTplHtml" size="small"><i class="fa fa-hand-o-up"></i>模板更新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Template',
  data () {
    return {
      tableData: [],
      tablePageinfo: {page: 1, total: 0},
      keywords: {},
      newCurr: {},
      newShow: false,
      currEdit: {},
      editShow: false,
      upurl: this.$apiurl,
      uploadattr: {method: 'base.upload'},
      tableLoad: false,
      shop: {},
      storetpl: [],
      devTpl: {},
      devShow: false,
      devHtml: '',
      currTpl: 'layout',
      currPath: 'layout.html',
      cmOptions: {
        mode: 'text/html',
        theme: 'blackboard',
        indentUnit: 4,
        smartIndent: true,
        tabSize: 4,
        readOnly: false,
        showCursorWhenSelecting: true,
        lineNumbers: true,
        firstLineNumber: 1
      }
    }
  },
  mounted () {
    this.getTableDate(1)
    this.getTplStandard()
  },
  methods: {
    handleTplHtml: function () {
      var that = this
      var para = {}
      para.html = that.devHtml
      para.tplpath = that.currPath
      para.themeId = that.devTpl.ID
      para.method = 'base.saveTplHtml'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          this.$message.success('模板保存成功')
        } else {
          this.$message.error('模板保存失败，请稍后重试')
        }
      })
    },
    /**
     * 编辑模板切换
     */
    changeTpl: function (name, path) {
      this.currTpl = name
      this.getTplHtml(path)
    },
    /**
     * 初始化开发模板
     */
    initDevTpl: function (row) {
      this.devTpl = row
      this.devShow = true
      this.curr = 'layout'
      this.getTplHtml('layout.html')
    },
    /**
     * 获得模板html
     */
    getTplHtml: function (path) {
      var that = this
      var para = {}
      para.method = 'base.getTplHtml'
      para.themeId = that.devTpl.ID
      para.tplpath = path
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        that.devHtml = ret.body.data
        this.currPath = path
      })
    },
    /**
     * 创建新的模板
     */
    handle: function (formName) {
      var that = this
      that.$refs[formName].validate(function (volid) {
        if (volid) {
          var para = that.newCurr
          para.method = 'base.initNewTemplate'
          that.$pageloading()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.$loadend()
            if (ret.data.data.code === 200) {
              this.$message.success('模板创建成功')
              that.getTableDate(that.tablePageinfo.page)
              that.newShow = false
            } else {
              this.$message.error('模板创建失败,请稍后重试')
            }
          })
        }
      })
    },
    /**
     * 初始化模板文件
     * @param themeId
     */
    createTplFiles: function (themeId) {
      var that = this
      var para = {}
      para.themeId = themeId
      para.method = 'base.inittpl'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          this.$message.success('模板文件初始化成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          this.$message.error('模板文件初始化失败，请稍后重试！')
        }
      })
    },
    /**
     * 获得模板标准
     */
    getTplStandard: function () {
      var that = this
      var para = {}
      para.method = 'base.getTplStandard'
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.storetpl = ret.body.data
      })
    },
    /**
     * 更换商城模板
     * @param themeId
     */
    tplExchange: function (themeId) {
      var that = this
      var para = {}
      para.themeId = themeId
      para.method = 'shop.changeShopTpl'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          this.$message.success('店铺模板修改成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          this.$message.error('店铺模板修改失败,请稍后重试')
        }
      })
    },
    /**
     * 获得模板分页
     * @param page
     */
    getTableDate: function (page) {
      var that = this
      var para = {}
      para.method = 'base.getMerchantThemePage'
      Object.assign(para, that.keywords)
      para.page = page
      para.num = 15
      that.tableLoad = true
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.tableLoad = false
        that.tableDate = ret.body.data.data
        that.tablePageinfo.page = page
        that.tablePageinfo.total = ret.body.data.total
        that.shop = ret.body.data.shop
      })
    },
    /**
     * 模板封面提交成功
     * @param response
     * @param file
     * @param fileList
     */
    handleShortcutSuccuss: function (response, file, fileList) {
      var that = this
      that.$set(that.newCurr, 'screenShot', response.data.url)
    }
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .tplcell:hover{ box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); }
</style>



// WEBPACK FOOTER //
// src/components/shop/Template.vue